import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import LoginButton from './LoginButton.js';

console.log("PVLogin React Component Initialized");

var login_element = document.getElementById('pv_login_button_container');
if(login_element){
  console.log("Rendering PvLoginButton: ");
  console.log(login_element.dataset);
  ReactDOM.render(<LoginButton locale={login_element.dataset.locale} fallback={login_element.dataset.wordpressfallback} pluginroot={login_element.dataset.pluginroot}/>, login_element);
}
